<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <b-card no-body>
        <b-tabs v-model="tabIndex" content-class="mt-3" fill>
          <b-tab class="" @click="notTryMfa">
            <template #title>
              Password Login<br>以密碼方式登入
            </template>
            <div id="my-captcha-container">
                <!-- The contents of this container will be replaced by the captcha widget -->
            </div>
            <!-- Login v1 -->
            <b-card class="mb-0 ll-loginbox">
              <!-- <b-link class="kerry-logo" v-if="host > -1">
              </b-link> -->
              <b-img  v-if="host > -1"
                :src="require('@/assets/images/imgs/kerryexpress.svg')"
                fluid
                style="max-width: unset !important;width: 60% !important;margin-left:20%"
                alt="logo"
              />
              <b-link class="brand-logo" v-else>
              </b-link>
              <!-- form -->
              <validation-observer
                ref="loginForm"
              >
                <b-form
                  class="auth-login-form mt-2"
                  @submit.prevent
                >
                  <!-- username -->
                  <b-form-group
                    label-for="username_notMfa"
                    label="Username"
                  >
                    <b-form-input
                      id="username_notMfa"
                      v-model="userInfoForm.username"
                      name="login-username"
                      placeholder="Username"
                      ref="username_notMfa"
                      autofocus
                      @keyup.enter="focusNext('password_notMfa')"
                    />
                  </b-form-group>

                  <!-- password -->
                  <b-form-group>
                    <div class="d-flex justify-content-between">
                      <label for="password_notMfa">Password</label>

                      <b-link :to="{name:'auth-forgot-password-v1'}" tabindex="-1">
                        <small>Forgot Password?</small>
                      </b-link>

                    </div>
                      <b-input-group
                        class="input-group-merge"
                      >
                        <b-form-input
                          id="password_notMfa"
                          v-model="userInfoForm.password"
                          :type="passwordFieldType"
                          class="form-control-merge"
                          name="login-password"
                          placeholder="Password"
                          ref="password_notMfa"
                        />

                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                  </b-form-group>

                  <!-- checkbox -->
                  <b-form-group>
                    <b-form-checkbox
                      id="remember-me"
                      v-model="status"
                      name="checkbox-1"
                      v-if="false"
                    >
                      Remember Me
                    </b-form-checkbox>
                  </b-form-group>


                </b-form>
              </validation-observer>
            </b-card>
            <!-- /Login v1 -->
            <!-- modal -->
            <b-modal
              id="demo-modal"
              ref="demo-modal"
              centered
              title=""
              size="xl"
              hide-footer
            >
              <div class="flex-grow-1">
                <b-card class="card-browser-states ll-backg ll-sHei ll-cardHei1">
                  <b-card-text>
                    <b-card-text>
                      <div class="row">
                        <div class="col-3 orange-text font-weight-bold">
                          <div style="font-size: 24px; margin-bottom: 10px;">Demo Screenshots 示範截圖</div>
                          <div style="font-size: 18px; margin-bottom: 10px;">
                          1. Watermark<br>
                          2A. PII Data Masking in UI<br>
                          </div>
                        </div>
                        <div class="col-9">
                          <img class="img-fluid" :src="require('@/assets/images/pages/demo_1.png')">
                        </div>
                      </div>
                        <div class="row">
                        <div class="col-3 orange-text font-weight-bold">
                          <div style="font-size: 18px; margin-bottom: 10px;">
                          2B. PII Data Unmasking by clicking EYE icon<br>
                          </div>
                        </div>
                        <div class="col-9">
                          <img class="img-fluid" :src="require('@/assets/images/pages/demo_2.png')">
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-text>
                </b-card>
              </div>
            </b-modal>
          </b-tab>
          <b-tab @click="tryMfa">
            <template #title>
              MFA Login<br>以MFA方式登入
            </template>
            <div id="my-captcha-container">
                <!-- The contents of this container will be replaced by the captcha widget -->
            </div>
            <!-- Login v1 -->
            <b-card class="mb-0 ll-loginbox">
              <!-- <b-link class="kerry-logo" v-if="host > -1">
              </b-link> -->
              <b-img  v-if="host > -1"
                :src="require('@/assets/images/imgs/kerryexpress.svg')"
                fluid
                style="max-width: unset !important;
        width: 60%; !important;margin-left:20%"
                alt="logo"
              />
              <b-link class="brand-logo" v-else>
              </b-link>
              <!-- form -->
              <validation-observer
                ref="loginForm"
              >
                <b-form
                  class="auth-login-form mt-2"
                  @submit.prevent
                >
                  <!-- username -->
                  <b-form-group
                    label-for="username_mfa"
                    label="Username"
                  >
                    <b-form-input
                      id="username_mfa"
                      v-model="userInfoForm.username"
                      name="login-username"
                      placeholder="Username"
                      autofocus
                      ref="username_mfa"
                      @keyup.enter="focusNext('password_mfa')"
                    />
                  </b-form-group>

                  <!-- password -->
                  <b-form-group>
                    <div class="d-flex justify-content-between">
                      <label for="password_mfa">Password</label>
                      <b-link :to="{name:'auth-forgot-password-v1'}" tabindex="-1">
                        <small>Forgot Password?</small>
                      </b-link>
                    </div>
                      <b-input-group
                        class="input-group-merge"
                      >
                        <b-form-input
                          id="password_mfa"
                          v-model="userInfoForm.password"
                          :type="passwordFieldType"
                          class="form-control-merge"
                          name="login-password"
                          placeholder="Password"
                          ref="password_mfa"
                        />

                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                  </b-form-group>

                  <b-form-group v-if="showFirstMfa">
                    <div class="d-flex justify-content-between">
                      <label for="email">MFA Method</label>
                    </div>
                    <b-input-group
                    >
                      <b-form-radio-group>
                        <b-form-radio
                          v-model="userInfoForm.mfaMethod"
                          name="mfaMethod"
                          value="EMAIL"
                          id="email"
                        />
                        <label for="email" class="switch-label mr-2">Email</label>
                        <b-form-radio
                          v-model="userInfoForm.mfaMethod"
                          name="mfaMethod"
                          value="SMS"
                          id="phone"
                        />
                        <label for="phone" class="switch-label">Mobile Number</label>
                      </b-form-radio-group>
                      <div class="h2 mb-0 ml-2">
                        <b-icon-question-circle-fill id="mfa-tip" style="color:grey"></b-icon-question-circle-fill>
                        <b-tooltip class="custom-tooltip" target="mfa-tip" triggers="hover">
                          驗證碼發送方式會以客戶首次登記時之選擇送出, 如有更改或需要協助, 請與我們客戶服務部聯絡。<br>The MFA code sending method will be sent according to first customer MFA registration. Please contact our customer service department for any changes or assistance.
                        </b-tooltip>
                      </div>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group v-if="showEmail">
                    <div class="d-flex justify-content-between">
                      <label for="email">Email</label>
                    </div>
                    <b-input-group
                      class="input-group-merge"
                    >
                      <b-form-input
                        id="email"
                        v-model="userInfoForm.email"
                        class="form-control-merge"
                        name="login-email"
                        placeholder="Email"
                        ref="email"
                      />
                    </b-input-group>
                  </b-form-group>
                  <b-form-group v-if="showPhone">
                    <div class="d-flex justify-content-between">
                      <label for="phone">Mobile Number</label>
                    </div>
                    <b-input-group
                      class="input-group-merge"
                    >
                      <b-form-input
                        id="phone"
                        v-model="userInfoForm.phone"
                        class="form-control-merge"
                        name="login-phone"
                        placeholder="Mobile Number"
                        ref="phone"
                      />
                    </b-input-group>
                  </b-form-group>

                  <b-form-group v-if="showMfaCode">
                    <div class="d-flex justify-content-between">
                      <label for="mfaCode">MFA Code</label>
                    </div>
                    <b-input-group
                      class="input-group-merge"
                    >
                      <b-form-input
                        id="mfaCode"
                        v-model="userInfoForm.mfaCode"
                        class="form-control-merge"
                        name="login-mfaCode"
                        placeholder="MFA Code"
                        ref="mfaCode"
                      />
                    </b-input-group>
                  </b-form-group>

                  <!-- checkbox -->
                  <b-form-group>
                    <b-form-checkbox
                      id="remember-me"
                      v-model="status"
                      name="checkbox-1"
                      v-if="false"
                    >
                      Remember Me
                    </b-form-checkbox>
                  </b-form-group>

                </b-form>
              </validation-observer>
            </b-card>
            <!-- /Login v1 -->
            <!-- modal -->
            <b-modal
              id="modal-details"
              ref="modal-details"
              centered
              title=""
              size="l"
              hide-footer
            >
              <div class="flex-grow-1">
                <b-card class="card-browser-states ll-backg ll-sHei ll-cardHei1">
                  <b-card-text>
                    <b-card-title class="text-center">
                      <h2 class="orange-text"><b>Customer Notice:</b></h2>
                      <h2 class="orange-text"><b>客戶通知:</b></h2>

                    </b-card-title>
                    <b-card-text>
                      <p class="clearer-text">
                        KEX Express is pleased to announce that our Send and Return Delivery Service is now available on our online ordering platform KEXOMS. This new feature is designed to make your delivery experience more convenient and efficient.
                        <br>
                        <br>

                        Please follow the instructions at the link below to learn how to use the service:
                        <br>
                        <br>

                        <a class="orange-button" v-on:click="downloadUserManual">[Click here for instructions]</a>
                        <br>
                        <br>

                        Furthermore, KEX OMS will implement the below User Interface (UI) Security Enhancements on 2 February 2026.
                        <br>
                        <br>

                        The system shall display a watermark on the user interface that includes the login account name and login time whenever Personally Identifiable Information (PII) such as the receiver’s name, address, and phone number is presented.
                        Personally Identifiable Information (PII) including the recipient company name, address, contact person’s name, phone number, and recipient’s email is masked by default.
                        <br>
                        <br>

                        <a class="orange-button" v-on:click="showDemo">[Click here for demos]</a>
                        <br>
                        <br>

                        For enquiries, please reach us at 35130888 or email to HK.KEX.CS HK.KEX.CS@kex.kln.com.
                        <br>
                        <br>

                        Thank you for choosing KEX Express. We look forward to serving you better with this enhanced delivery option!
                        <br>
                        <br>

                        KEX Express 很高興宣布，我們的 寄件及退件服務 現已於線上訂購平台 KEXOMS 上提供。此新功能旨在讓您的寄送體驗更加便利與高效。
                        <br>
                        <br>

                        請依照以下連結中的指引學習如何使用此服務：
                        <br>
                        <br>
                        <a class="orange-button" v-on:click="downloadUserManual">[點擊此處查看指引]</a>
                        <br>
                        <br>

                        此外，KEX OMS 將於 2026 年 2 月 2 日 實施以下使用者介面 (UI) 安全強化措施：
                        <br>
                        <br>

                        在顯示個人識別資訊 (PII) 包括收件人姓名、地址及電話號碼時，用戶頁面會顯示浮水印包括登入帳戶名稱及時間。
                        個人識別資訊 (PII) 包括收件公司名稱、地址、聯絡人姓名、電話號碼及收件人電郵會預設為遮蔽。
                        <br>
                        <br>

                        <a class="orange-button" v-on:click="showDemo">[點擊此處查看示範]</a>
                        <br>
                        <br>

                        如有查詢，請致電 35130888 或電郵至 HK.KEX.CS@kex.kln.com。
                        <br>
                        <br>

                        感謝您選擇 KEX Express。我們期待透過此強化的寄送選項為您提供更優質的服務！
                        <br>
                      </p>
                    </b-card-text>
                  </b-card-text>
                </b-card>
              </div>
            </b-modal>
          </b-tab>
        </b-tabs>
        <div class="mb-2" v-if="showV2Recaptcha">
          <GoogleRecaptcha>
            ref="GoogleRecaptcha"
            @getValidateCode="getValidateCode"
          ></GoogleRecaptcha>
        </div>

        <!-- submit button -->
        <b-button
          variant="primary"
          type="submit"
          block
          @click.prevent="recaptcha"
          :disabled="disabled"
          :style="{'cursor': disabled ? 'no-drop' : 'pointer'}"
        >
          Sign in
        </b-button>

        <b-button
          variant="secondary"
          type="submit"
          block
          @click.prevent="resendMfaCode"
          :disabled="disableResend"
          :style="{'cursor': disableResend ? 'no-drop' : 'pointer'}"
          v-if="showResendMfaCode"
        >
          Resend MFA Code {{ disableCount > 0 ? '(' + disableCount + ')' : '' }}
        </b-button>

        <b-form-group class="pt-1 text-center">
              <b-link :to="{name:'track'}">
            <small>Public Track and Trace</small>
          </b-link>
<!--          <a href="https://www.kex.kln.com/zh/track" target="_blank">-->
<!--            <small>Public Track and Trace</small>-->
<!--          </a>-->
        </b-form-group>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BImg,
  BIconQuestionCircleFill,
  BTabs,
  BTab
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { debounce } from "@/libs/fun.js"
import GoogleRecaptcha  from "@core/components/GoogleRecaptcha/GoogleRecaptcha.vue";

export default {
  components: {
    BImg,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTab,
    BCard,
    BCardTitle,
    BLink,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BIconQuestionCircleFill,
    GoogleRecaptcha: GoogleRecaptcha
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userInfoForm: {
        recaptchaToken: null,
        recaptchaTokenV2: null,
        username: null,
        password: null,
        deviceId: null,
        email: null,
        phone: null,
        mfaMethod: null,
        mfaContact: null,
        mfaCode: null,
        askedMfa: true,
        tryMfa: false,
      },
      status: '',
      // validation rules ordering.hk.kerryexpress.com
      required,
      email,
      disabled: null,
      disableResend: true,
      disableCount: 60,
      showMfaCode: false,
      showV2Recaptcha: false,
      showResendMfaCode: false,
      showFirstMfa: false,
      showEmail: false,
      showPhone: false,
      modalMessage: '',
      host:window.location.host.indexOf('ordering.hk.kerryexpress.com')>0?window.location.host.indexOf('ordering.hk.kerryexpress.com'):window.location.host.indexOf('ordering.kex.kln.com'),
      tabIndex: 0
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    'userInfoForm.username'(val) {
      if (val !== '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    'userInfoForm.password'(val) {
      if (val !== '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    'userInfoForm.mfaMethod'(val) {
      if (val === 'EMAIL') {
        this.showEmail = true
        this.showPhone = false
        this.$nextTick(() => this.$refs.email.focus())
      } else {
        this.showEmail = false
        this.showPhone = true
        this.$nextTick(() => this.$refs.phone.focus())
      }
    },
  },
  created() {
    // if (this.userInfoForm.username === null || this.userInfoForm.password === null) {
    //   this.disabled = true
    // } else {
    //   this.disabled = false
    // }
    // console.info(this.host>-1,'0--')
  },
  mounted() {
    sessionStorage.clear()
    // localStorage.clear()
    this.getCookie()
    // this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: "Notice: Further to the announcement made by our CEO on 4 March 2025, we would like to inform you that our website domain name will be changed with effect from 30 May 2025.",
    //         sub_title: "Our website domain ordering.hk.kerryexpress.com will no longer be in use and be automatically redirected to ordering.kex.kln.com until 30 June 2025. If you have links on your website which point to ordering.hk.kerryexpress.com, you may wish to update them to ordering.kex.kln.com.",
    //         icon: 'AlertOctagonIcon',
    //         type: 'warn',
    //         enableHtml: true,
    //         escapeMarkup: false, // Add this line
    //       },
    //     }, {
    //       timeout: 60000,
    //     }
    // )
    this.$refs['modal-details'].show()
  },
  destroyed() {},
  methods: {
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "doLogin".
      this.userInfoForm.recaptchaToken = await this.$recaptcha('doLogin')
      console.log("token: " + this.userInfoForm.recaptchaToken)

      this.doLogin()
    },
    getCookie() {
      if (document.cookie.length>0) {
        const arr=document.cookie.split('; ')
        // console.log(arr)
        if (arr[1] !== undefined) {
          const ati = arr[1].split('=')
          this.userInfoForm._ati = ati[1]
          if (arr[2] !== undefined) {
            const token = arr[2].split('=')
            sessionStorage.setItem('token', token[1])
            axios.defaults.headers.Authorization = token[1]
          }
        } else {
          const c = document.cookie
          const a = c.lastIndexOf('\=')
          this.userInfoForm._ati = c.substring(a+1, c.length)
        }
      }
      if (localStorage.getItem('userInfo') !== null) {
        this.$router.push({ name: 'dashboard' })
      }
      const uuid = this.$uuid.v4()
      if (this.$cookies.get('uuid') !== undefined) {
        this.userInfoForm.deviceId = this.$cookies.get('uuid')
        if (this.userInfoForm.deviceId === null) {
          this.userInfoForm.deviceId = uuid
          this.$cookies.set('uuid', uuid, 60 * 60 * 24 * 30)
        }
      } else {
        // generate uuid
        this.$cookies.set('uuid', uuid, 60 * 60 * 24 * 30)
        this.userInfoForm.deviceId = uuid
      }
      // console.log(this.userInfoForm.deviceId)
    },
    focusNext() {
      this.$refs.pwd.focus()
    },
    validationForm() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          // this.doLogin()
          this.recaptcha()
        }
      })
    },
    tryMfa() {
      this.showFirstMfa = true
      this.userInfoForm.askedMfa = true
      this.userInfoForm.tryMfa = true
      this.$refs['modal-details'].hide()
      this.$nextTick(() => this.$refs.username_mfa.focus())
    },
    notTryMfa() {
      this.showFirstMfa = false
      this.userInfoForm.askedMfa = true
      this.userInfoForm.tryMfa = false
      this.$refs['modal-details'].hide()
      // focus on username input
      this.$nextTick(() => this.$refs.username_notMfa.focus())
      // // this.doLogin()
      // this.recaptcha()
    },
    resendMfaCode() {
      this.userInfoForm.mfaCode = null
      // this.doLogin()
      this.recaptcha()
    },
    downloadMfaInstruction: debounce(function() {
      let url = axios.defaults.baseURL+`/user/downloadMfaInstruction`
      window.open(url, "_self")
    }, 1000),
    downloadUserManual: debounce(function() {
      let url = axios.defaults.baseURL+`/user/downloadUserManual`
      window.open(url, "_blank")
    }, 1000),
    showDemo: debounce(function() {
      this.$refs['demo-modal'].show()
    }, 500),
    doLogin() {
      this.disableCount = 60
      this.disableResend = true
      if (this.userInfoForm.mfaMethod == 'EMAIL') {
        this.userInfoForm.mfaContact = this.userInfoForm.email
      }
      if (this.userInfoForm.mfaMethod == 'SMS') {
        this.userInfoForm.mfaContact = this.userInfoForm.phone
      }
      this.$http.post('/user/login', this.userInfoForm).then(res => {
        const info = res.data.data
        if (res.data.message == "-1") {
          this.showV2Recaptcha = true
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please verify you are not a robot",
              icon: 'CrosshairIcon',
              type: 'info',
            },
          })
          return true;
        }
        else if (res.data.message == "1003") {
          // redirect to reset password page
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please reset your password",
              icon: 'CrosshairIcon',
              type: 'info',
            },
          })
          this.$router.push({ name: 'updatePassword', params: {
            username: this.userInfoForm.username,
            password: this.userInfoForm.password,
          }})
        }
        else if (res.data.message == "1002") {
          // this.$refs['modal-details'].show()
          console.log(this.tabIndex)
          if (this.tabIndex == 0) {
            this.tabIndex = 1
            this.tryMfa()
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please use MFA to login",
              icon: 'CrosshairIcon',
              type: 'info',
            },
          })
          return true;
        }
        // if require mfa code, show mfa code input
        else if (res.data.message == "1000" || res.data.message == "1001") {
          if (this.tabIndex == 0) {
            this.tabIndex = 1
            this.tryMfa()
          }
          this.showMfaCode = true
          this.showResendMfaCode = true
          // count down 60s to make resend button enable
          this.disableCount = 60
          const timer = setInterval(() => {
            this.disableCount -= 1
            if (this.disableCount <= 0) {
              clearInterval(timer)
              this.disableResend = false
            }
          }, 1000)
          if (res.data.message == "1000") {
            if (this.userInfoForm.email == null) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Please check your email and enter the MFA code",
                  icon: 'CrosshairIcon',
                  type: 'info',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Please check your email: " + this.userInfoForm.email + " and enter the MFA code",
                  icon: 'CrosshairIcon',
                  type: 'info',
                },
              })
            }
          } else if (res.data.message == "1001") {
            if (this.userInfoForm.phone == null) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Please check your mobile number and enter the MFA code",
                  icon: 'CrosshairIcon',
                  type: 'info',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Please check your mobile number: " + this.userInfoForm.phone + " and enter the MFA code",
                  icon: 'CrosshairIcon',
                  type: 'info',
                },
              })
            }

          }


          this.$nextTick(() => this.$refs.mfaCode.focus())
          return true;
        } else if (res.data.code != 200) {
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: res.data.message,
          //     icon: 'XIcon',
          //     variant: 'danger',
          //   },
          // })
          return false;
        } else {
          localStorage.setItem('userInfo', JSON.stringify(info))
          sessionStorage.setItem('token', info.token)
          sessionStorage.setItem('userInfo', JSON.stringify(info))
          let spaceInfo = {
            usedSpace: info.usedSpace,
            freeSpace: info.freeSpace,
            totalSpace: info.totalSpace
          }
          sessionStorage.setItem('spaceInfo', JSON.stringify(spaceInfo))
          // window.document.cookie= JSON.stringify(info)
          // const token = sessionStorage.getItem('token')
          let token = JSON.parse(localStorage.getItem('userInfo')).token
          axios.defaults.headers.Authorization = token
          if (token !== null) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Login Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'dashboard' })
          }
        }
      }).catch(error => {
        // console.log(error)
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Server is bussy now, please try again later',
        //     icon: 'XIcon',
        //     variant: 'danger',
        //   },
        // })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style scoped>
.ll-loginbox > .card-body{
  padding: 5rem 1.5rem 0rem 1.5rem;
}
.brand-logo {
  width: 100%;
  height: 80px;
}
.kerry-logo{
  width: 100% !important;
  height: 80px !important;
}
.kerry-mfa-logo{
  text-align: center;
  width: 100% !important;
  height: 50px !important;
  background: url('../../assets/images/imgs/kerryexpress.svg') no-repeat center !important;
  background-size: 50% !important;

}
.ll-loginbox .kerry-logo{
  background: url('../../assets/images/imgs/kerryexpress.svg') no-repeat center !important;
  background-size: 80%;
}
.ll-loginbox .brand-logo{
  background: url('../../assets/images/imgs/loginLogo.svg') no-repeat center;
  background-size: 80%;
}
.orange-text {
  color: #FB7800 !important;
  background: transparent !important;
}
.orange-button {
  color: white !important;
  background: #FB7800 !important;
}

.clearer-text {
  font-size: 1.12rem !important;
  font-family: sans-serif !important;
}

.custom-tooltip > .tooltip-inner {
  max-width: 1000px !important;
  width: 500px !important;
}
</style>
